import React from 'react';
import { useTranslation } from 'react-i18next';
import ContactUs from '../components/contactUs/ContactUs';
import ServicesComponent from '../components/ServicesComponents/ServicesComponent';
import illustration from '../assests/website.png';

const WebDevelopmentPage = () => {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language?.startsWith('en');
  const benefits = isEnglish
    ? ['Websites that work on mobile, tablet and desktop.', 'Design and functionality shaped around your business.', 'Help with new websites and improvements to existing ones.']
    : ['Webbplatser som fungerar på mobil, surfplatta och dator.', 'Design och funktioner anpassade efter din verksamhet.', 'Hjälp med nya webbplatser och förbättringar av befintliga.'];

  return (
    <main>
      <ServicesComponent
        img={illustration}
        thead="Web Development"
        idName="web-development"
        desc={isEnglish
          ? 'Make it easy for customers to discover your business and get in touch. We help you plan, design and develop a website around your goals, with clear content, useful features and a welcoming experience.'
          : 'Gör det enkelt för kunder att hitta ditt företag och ta kontakt. Vi hjälper dig att planera, designa och utveckla en webbplats utifrån dina mål, med tydligt innehåll, användbara funktioner och en välkomnande upplevelse.'}
      >
        <ul className="service-components-benefits">{benefits.map((benefit) => <li key={benefit}>{benefit}</li>)}</ul>
      </ServicesComponent>
      <div id="contact"><ContactUs border defaultService="web-development" /></div>
    </main>
  );
};

export default WebDevelopmentPage;
